module.exports = __webpack_public_path__ + "img/bg_dbd48e8.webp";